import React from "react";

const RecentHotelBooking = ({ TableData }) => {
  return (
    <>
      <div className="p-2 bg-white rounded-md">
        <div className="py-2">
          <p className="text-md font-semibold">Recent Hotel Bookings</p>
        </div>
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                #
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Invoice ID
              </th>

              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Hotel
              </th>

              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Total
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Paid
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Status
              </th>

              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Date
              </th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {TableData?.recentHotelBookings?.length > 0 ? (
              <>
                {TableData?.recentHotelBookings.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-700">
                      {index + 1}
                    </td>

                    <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                      {item.invoiceId}
                    </td>

                    <td className="px-4 py-3 text-sm text-gray-700">
                      {item.hotelName}
                    </td>

                    <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                      {item.totalAmount}
                    </td>

                    <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                      {item.paidAmount}
                    </td>

                    <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                      <span
                        className={`px-2 py-1 rounded text-xs ${
                          item.paymentStatus === "Paid"
                            ? "bg-green-100 text-green-700"
                            : "bg-orange-100 text-orange-700"
                        }`}
                      >
                        {item.paymentStatus === "Paid" ? "Paid" : "Unpaid"}
                      </span>
                    </td>

                    <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <>
                <tr>
                  <td
                    colSpan={7}
                    className="px-4 py-3 text-sm text-center text-gray-700 text-nowrap"
                  >
                    No Data to Show
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RecentHotelBooking;
